import { Controller } from 'stimulus';
import CheckedCircle from '../images/check-circle.svg';

const csrfParamSelector = "head meta[name='csrf-param']";
const csrfTokenSelector = "head meta[name='csrf-token']";

export default class extends Controller {
  static targets = [
    'email',
    'emailConfirmation',
    'emailSummaryLink',
    'errorMessage',
    'form',
    'modal',
    'printLink',
  ];

  get modal() {
    return this.application.getControllerForElementAndIdentifier(
      this.modalTarget,
      'modal'
    );
  }

  disable() {
    this.emailSummaryLinkTarget.setAttribute('disabled', true);
    this.printLinkTarget.setAttribute('disabled', true);
  }

  enable() {
    this.emailSummaryLinkTarget.removeAttribute('disabled');
    this.printLinkTarget.removeAttribute('disabled');
  }

  connect() {
    this._csrfParam = document.querySelector(csrfParamSelector).content;
    this._csrfToken = document.querySelector(csrfTokenSelector).content;
  }

  print(event) {
    event.preventDefault();
    this._sendEvent('opened_steps_print_dialog');
    window.print();
  }

  showEmailModal(event) {
    event.preventDefault();
    this._sendEvent('opened_steps_email_modal');
    this.modal.open();
  }

  async sendSummary(event) {
    event.preventDefault();

    this._clearErrors();

    if (this.emailTarget.validity.valid) {
      this._performSend(event.target.action);
    } else {
      this._showErrors(this.emailTarget.validationMessage);
    }
  }

  _clearErrors() {
    this.emailTarget
      .closest('.o-form-field')
      .classList.remove('o-form-field--error');
    this.hasErrorMessageTarget && this.errorMessageTarget.remove();
  }

  async _performSend(url) {
    const body = JSON.stringify({
      email: this.emailTarget.value,
      [this._csrfParam]: this._csrfToken,
    });

    await fetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body,
    })
      .then(response => response.json())
      .then(json => {
        if (json.errors) {
          this._showErrors(json.errors[0]);
        } else {
          this._sendEvent('sent_steps_email');
          this._showThankYou();
        }
      });
  }

  _sendEvent(action) {
    if (typeof window.gtag === 'undefined') {
      return;
    }

    gtag('event', action, {
      event_category: 'step_actions',
    });
  }

  _showErrors(message) {
    const fieldContainer = this.emailTarget.closest('.o-form-field');

    fieldContainer.classList.add('o-form-field--error');
    fieldContainer.insertAdjacentHTML(
      'beforeend',
      `<p class="error-message" data-target="client-actions.errorMessage">
        ${message}
      </p>`
    );
  }

  _showThankYou() {
    this.formTarget.classList.add('u-is-hidden');
    this.emailConfirmationTarget.classList.remove('u-is-hidden');
  }
}
